// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
/**
 * @packageDocumentation
 * @module extensionmanager
 */
export * from './model';
export * from './widget';
//# sourceMappingURL=index.js.map